<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="p-3 card">
                <div class="form-group row">
                    <div class="col-lg-6">
                        <div style="display: flex; flex-wrap: nowrap; height: 30px">
                          <label>{{ "Decision" | translate }}</label>
                          <span *ngIf="Decision.invalid" class="alert"
                            style="color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px;">
                            <div *ngIf="Decision.errors?.required">*</div>
                          </span>
                        </div>
                        <ng-select
                          id="Decision"
                          name="Decision"
                          required
                          #Decision="ngModel"
                          class="form-control-select"
                          [items]="decisionsArr"
                          bindLabel="text"
                          bindValue="id"
                          [(ngModel)]="decisionId"
                          [ngModelOptions]="{ standalone: true }"
                          placeholder="{{ 'Decision' | translate }}"
                        >
                        </ng-select>
                    </div>
                </div>
                <div class="form-group row mt-3">
                    <div class="col-lg-6">
                      <div style="display: flex; flex-wrap: nowrap; height: 30px">
                        <label>{{ "Description" | translate }}</label>
                        <span
                          *ngIf="Description.invalid"
                          class="alert"
                          style="
                            color: red;
                            white-space: nowrap;
                            line-height: 0;
                            padding: 0;
                            margin-top: 8px;
                          "
                        >
                          <div *ngIf="Description.errors?.required">*</div>
                        </span>
                      </div>
                      <textarea
                        id="Description"
                        required
                        #Description="ngModel"
                        class="form-control"
                        rows="2"
                        [(ngModel)]="description"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="{{ 'Description' | translate }}"
                      >
                      </textarea>
                    </div>
                    
                </div>
                <div class="row col-lg-6 justify-content-center mt-3 mb-4">
                    <button [disabled]="Decision.invalid || Description.invalid"(click)="delegationSubmit()"  class="col-3 btn btn-primary m-2">
                        {{'Send' | translate}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
